import startup from "../common/startup";
import App from "./App";
import store from "./store";

startup(App, store, null, "home-app", false);
